import store from '@appStore/store'
import {
	NOTIFICATION,
	type NotiFicationDatum,
	type SnackKey
} from 'config/notifications'

import { actions } from '../slice'

const showSnack = (message: NotiFicationDatum) =>
	store.dispatch(actions.showSnack(message))

function snackById(key: SnackKey) {
	const message = NOTIFICATION[key]
	showSnack(message)
}

export { showSnack, snackById }
